import { branch, renderComponent } from 'recompose'
import InviteSelectUsers from './InviteSelectUsers'
import InviteSelectUsersAndTeams from './InviteSelectUsersAndTeams'

export default branch(
  props => !!props.teams,
  renderComponent(InviteSelectUsersAndTeams),
  renderComponent(InviteSelectUsers),
)()



// WEBPACK FOOTER //
// ./src/scripts/components/shared/InviteSelect/index.js